import React, { useState, useEffect, useRef, useContext } from 'react';
import View from './View';
import MountainsCoordinates from './MountainsCoordinates';
import Form from './Form';
import styles from '../../css/wheater.module.css';
import Bars from '../Bars';
import { NavLink } from 'react-router-dom';
import { FiArrowLeft } from "react-icons/fi";
import Sentence from '../info/Sentence';
import { AvalancheContext } from '../context/AvalancheContext'; // import kontekstu
import axios from 'axios';

function App() {

  const { level, setLevel } = useContext(AvalancheContext);

useEffect(() => {
  const fetchAvalancheLevel = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/admin-api/avalanche-level`);
      
      const { level: fetchedLevel} = res.data;

      if (fetchedLevel){
        setLevel(fetchedLevel);
      } else {
        setLevel('');
      }
    } catch (err) {
      console.error('Błąd pobierania poziomu lawinowego:', err);
      setLevel('');
    }
  };

  fetchAvalancheLevel();
}, [setLevel]);



  const [text, setText] = useState('');
  const [place, setPlace] = useState('');
  const [current, setCurrent] = useState({});
  const [daily, setDaily] = useState([]);
  const [err, setErr] = useState(false);
  const [elevation, setElevation] = useState(0);
  const [hourly, setHourly] = useState({});

  const namePlaceRef = useRef();

  const fetchWeatherFromName = async (placeName) => {
    try {
      const allowedCountries = ["PL"];

      let res = await fetch(
        `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(placeName)}&count=5&language=pl&format=json`
      );
      let geoData = await res.json();
      let result = geoData.results?.find(r => allowedCountries.includes(r.country_code));

      if (!result) {
        res = await fetch(
          `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(placeName)}&count=1&language=pl&format=json`
        );
        geoData = await res.json();
        result = geoData.results?.[0] || null;
      }

      if (!result) {
        setErr(true);
        setPlace(placeName);
        return;
      }

      const { latitude, longitude, name, elevation } = result;

      await fetchWeather({
        name,
        lat: latitude,
        lon: longitude,
        elv: elevation
      });

      setText('');
      setErr(false);
    } catch (e) {
      console.error(e);
      setErr(true);
      setPlace(placeName);
    }
  };


  const fetchWeather = async ({ name, lat, lon, elv }) => {
    
    try {

      const [weatherRes , uvRes] = await Promise.all ([

        fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&models=icon_seamless&current_weather=true&daily=cloudcover_mean,visibility_mean,snowfall_sum,sunrise,sunset,temperature_2m_max,temperature_2m_min,windspeed_10m_max,windspeed_10m_min,precipitation_sum,weathercode&hourly=temperature_2m,apparent_temperature,precipitation,weathercode,windspeed_10m,windgusts_10m,visibility,snowfall,snow_depth,cloudcover,cape,freezing_level_height&timezone=Europe/Warsaw`
        ),

        fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&daily=uv_index_max&timezone=Europe/Warsaw`
        )

      ]) 
    

      const weatherData = await weatherRes.json();
      const uvData = await uvRes.json();

      setPlace(name);
      setElevation(elv);
      setCurrent(weatherData.current_weather || {});
      
      setDaily(weatherData.daily.time.slice(0, 6).map((date, i) => ({
        date,
        sunrise: weatherData.daily.sunrise[i],
        sunset: weatherData.daily.sunset[i],
        temp_max: weatherData.daily.temperature_2m_max[i],
        temp_min: weatherData.daily.temperature_2m_min[i],
        precipitation: weatherData.daily.precipitation_sum[i],
        wind_min: weatherData.daily.windspeed_10m_min[i],
        wind_max: weatherData.daily.windspeed_10m_max[i],
        snowfall_sum: weatherData.daily.snowfall_sum[i],
        weathercode: weatherData.daily.weathercode[i],
        cloudcover_mean: weatherData.daily.cloudcover_mean[i],
        visibility_mean: weatherData.daily.visibility_mean[i],

        uv_index_max:
          uvData?.daily?.uv_index_max?.[i] ??
          weatherData?.daily?.uv_index_max?.[i] ??
          null
     
      })));


      setHourly({
        time: weatherData.hourly.time,
        temp: weatherData.hourly.temperature_2m,
        feels: weatherData.hourly.apparent_temperature,
        precip: weatherData.hourly.precipitation,
        code: weatherData.hourly.weathercode,
        wind: weatherData.hourly.windspeed_10m,
        wind_gusts: weatherData.hourly.windgusts_10m,
        visibility: weatherData.hourly.visibility,
        snowfall: weatherData.hourly.snowfall,
        snow_depth: weatherData.hourly.snow_depth,
        storm_risk: weatherData.hourly.cape,
        cloudcover: weatherData.hourly.cloudcover,
        freezing_height: weatherData.hourly.freezing_level_height
      });

      setErr(false);
    } catch (err) {
      console.error(err);
      setPlace(name);
      setErr(true);
    }
  };

  const handleInputChange = (e) => setText(e.target.value);

  const handleNamePlaceRef = () => {
    namePlaceRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setText('');
  };

  return (
    <>
      <NavLink to="/" className="backLink userSelectNone">
        <FiArrowLeft className="backIcon" />
        <span>Powrót</span>
      </NavLink>

      <div className={`${styles['app-wheater']} userSelectNone`}>
        <h3 className='h3-header' aria-label="Górska Pogodynka">
          <img src="/logo/logoApp.png" alt="logo" className='logo' /> Górska Pogodynka
        </h3>

        <Sentence />

        { level && (Number(level)>0)?<p style={{margin:'3vh auto'}}>⚠️ Stopień lawinowy w Tatrach: <strong>{level}</strong>  </p>:null}

        

        <Form
          onSelectName={fetchWeatherFromName}
          change={handleInputChange}
          text={text}
          click={handleNamePlaceRef}
        />
        <MountainsCoordinates
          onSelect={fetchWeather}
          click={handleNamePlaceRef}
        />

        <View data={{ place, current, daily, hourly, err, elevation }} namePlaceRef={namePlaceRef} />

        <Bars />
      </div>
    </>
  );
}

export default App;
